import { ComponentIds } from '@inter-ikea-core/core';
import { ProductType } from '../types';
import ProductInfoComponent from '../core-api/components/ProductInfoComponent';
/*
 * Return the handle connector on the door that is closest to 90 cm above floor
 */
export const getHandleConnectorForDoor = (doorEntity, handleEntity) => {
    const handleType = handleEntity.getComponent(ProductInfoComponent.id)
        ?.productType;
    const handleConnectorsOnDoor = doorEntity
        .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
        ?.connectors?.filter((c) => handleType === ProductType.EDGE_HANDLE
        ? c.tags().includes('door-handle-attach-edge')
        : c.tags().includes('door-handle-attach'));
    if (!handleConnectorsOnDoor)
        return null;
    let currentConnector = handleConnectorsOnDoor[0];
    handleConnectorsOnDoor.forEach((connector) => {
        const position = connector.getWorldPositionFromOwnerEntity(doorEntity);
        const currentPosition = currentConnector.getWorldPositionFromOwnerEntity(doorEntity);
        if (Math.abs(position.Y - 900) < Math.abs(currentPosition.Y - 900)) {
            currentConnector = connector;
        }
    });
    return currentConnector;
};
//# sourceMappingURL=handlePlacement.js.map